import { Image, Spin } from "antd";
import "./ImageGallery.css";

const ImageGallery = ({ generatedImages = [], loading}) => {
  return (
     <Image.PreviewGroup>
      <div className="gallery">
        {generatedImages.map((img, i) => (
          <div key={img?.id ?? i} className="thumb" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            {loading ? <Spin /> : <Image src={img?.url?.signed_url} className="thumb" />}
          </div>
        ))}
      </div>
    </Image.PreviewGroup>
  );
};

export default ImageGallery;